import {useSelector} from 'react-redux';
import {
  selectInitialDate,
  selectNextAvailableDateFromInitialDate,
  selectTimeslotsInitialDate,
} from '../store/slices/selectors';
import dayjs from 'dayjs';

export const useGenerateDayWithAvailabilityFromInitialDate = () => {
  const initialDate = useSelector(selectInitialDate);
  const initialDateTimeslots = useSelector(selectTimeslotsInitialDate);
  const nextAvailableDateFromInitialDate = useSelector(
    selectNextAvailableDateFromInitialDate,
  );

  if (!nextAvailableDateFromInitialDate) {
    return -1;
  }

  if (initialDateTimeslots.length !== 0) {
    return 0;
  }

  const nextAvailableDate = dayjs(nextAvailableDateFromInitialDate.date);
  const daysDifference = nextAvailableDate.diff(initialDate, 'day');
  return daysDifference;
};
